import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { from, mergeMap, Observable } from 'rxjs';
import { Token } from '../services/auth/token';
import { JIT_ENDPOINTS } from '../api/jit/jit-api';
import { WAGER_ENDPOINTS } from '../api/wager/wager-api';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const authenticatedUrls = [
      `${environment.walletApi}/${JIT_ENDPOINTS.GENERATE_TOKEN}`,
      `${environment.walletApi}/${JIT_ENDPOINTS.DEFAULT_WALLET}`,
      `${environment.walletApi}/${JIT_ENDPOINTS.FCM_TOKEN}`,
      `${environment.walletApi}/${JIT_ENDPOINTS.SET_LIGHTNING_ADDRESS}`,
      `${environment.walletApi}/${JIT_ENDPOINTS.DELETE_ACCOUNT}`,
      `${environment.walletApi}/${JIT_ENDPOINTS.NICK}`,
      `${environment.walletApi}/${JIT_ENDPOINTS.PROFILE}`,
      `${environment.walletApi}/${JIT_ENDPOINTS.GEOCODE}`,
      `${environment.wagerApi}/${WAGER_ENDPOINTS.FCM_TOKEN}`,
      `${environment.wagerApi}/${WAGER_ENDPOINTS.NICK}`,
      `${environment.wagerApi}/${WAGER_ENDPOINTS.PROVISION_USER}`,
    ];

    if (authenticatedUrls.some((url) => request.url.includes(url))) {
      const forceRefresh = request.url.includes(WAGER_ENDPOINTS.PROVISION_USER);
      return from(Token.get(forceRefresh)).pipe(
        mergeMap((token) => {
          if (token) {
            request = request.clone({
              setHeaders: { Authorization: `Bearer ${token}` },
            });
          }
          return next.handle(request);
        }),
      );
    }
    return next.handle(request);
  }
}
